import { createContext } from 'react';

export const LegalModalContext = createContext<{
  /** True if the legal modal should be displayed above the webapp, and block
   * any new network transactions until it has been closed */
  shouldShowLegalModal: boolean;
}>({ shouldShowLegalModal: false });
